import React from 'react';
import { LockOutlined } from '@ant-design/icons';
import { omit, get } from 'lodash';
import { Button, Input, notification, message, Form } from 'antd';
import { loginAsync, LOGIN_CHANGE } from 'actions';
import { Cognito } from '@xbcb/aws-utils';
// import reportError from 'libs/reportError';
import PasswordHelper from 'components/PasswordHelper';
// import InltTermsModal from 'components/InltTermsModal';
import { FormItem } from '@xbcb/form-item-components';
import { shouldUpdate } from '@xbcb/ui-utils';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

const NewPasswordForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { flow, user, verificationCode, userAttributes, isLoading } =
    useSelector((state) => get(state, 'ui.login', {}));

  const handleSubmit = async (evt: any) => {
    dispatch(LOGIN_CHANGE({ isLoading: true }));
    form
      .validateFields()
      .then(async (values) => {
        if (flow === 'forgot') {
          try {
            await Cognito.confirmPassword(
              user,
              verificationCode,
              values.newPassword,
            );
            dispatch(
              LOGIN_CHANGE({
                form: 'login',
                flow: 'login',
                isLoading: false,
                delivery: {},
                user: {},
              }),
            );
            notification['success']({
              message: 'Success!',
              description:
                'Your password has been changed. You can now login using your new one.',
              duration: 8,
            });
          } catch (e) {
            let msg = (e as any).message;
            if (msg.indexOf('password') !== -1) {
              msg = 'Password must be length 8 or greater';
              dispatch(LOGIN_CHANGE({ isLoading: false }));
            } else if (msg.indexOf('expired') !== -1) {
              dispatch(
                LOGIN_CHANGE({
                  form: 'login',
                  flow: 'login',
                  isLoading: false,
                  delivery: {},
                  user: {},
                }),
              );
            } else if (msg.indexOf('verification') !== -1) {
              dispatch(
                LOGIN_CHANGE({
                  form: 'verification',
                  isLoading: false,
                }),
              );
            } else {
              if ((e as any).code !== 'InvalidPasswordException') {
                // reportError(e);
              }
              dispatch(LOGIN_CHANGE({ isLoading: false }));
            }
            message.error(msg, 3.5);
          }
        } else {
          // TODO consider allowing users to change email, right now we omit or else get an error from cognito
          try {
            const result = await Cognito.submitNewPassword(
              user,
              omit(userAttributes, ['email', 'phone_number_verified']),
              values.newPassword,
            );
            const userToken = result.getIdToken().getJwtToken();
            const newUserAttributes = await Cognito.getUserAttributes();
            const isOnboardingLogin =
              get(newUserAttributes, ['custom:type']) === 'onboarding';
            let loginParams = newUserAttributes;
            // We only omit email for non-onboarding account
            if (!isOnboardingLogin) {
              delete newUserAttributes.email;
              loginParams = omit(newUserAttributes, ['email']);
            }
            await dispatch(loginAsync({ ...loginParams, userToken }));
            notification.success({
              message: 'Welcome!',
              description: 'You have successfully activated your account.',
              duration: 5.5,
            });
            if (!location.search.startsWith('?redirect=')) history.push('/');
            else history.push(location.search.split('=')[1]);
            dispatch(LOGIN_CHANGE({ isLoading: false }));
          } catch (e) {
            if ((e as any).code !== 'InvalidPasswordException') {
              // reportError(e);
            }
            message.error((e as any).message, 3.5);
            dispatch(LOGIN_CHANGE({ isLoading: false }));
          }
        }
      })
      .catch(async (err) => {
        if (err) {
          const msg = err.confirmNewPassword
            ? 'Passwords must match'
            : 'Password must be at least 8 characters long';
          message.error(msg, 3.5);
          dispatch(LOGIN_CHANGE({ isLoading: false }));
        }
      });
  };

  // handleShowInltTermsModal = () => {
  //   dispatch(TOGGLE_MODAL({ key: 'inltTerms' }));
  // };

  // handleConfirm = () => {
  //   this.setState({ hasReadTermsOfService: !this.state.hasReadTermsOfService });
  // };

  // const { hasReadTermsOfService } = this.state;
  return (
    <Form onFinish={handleSubmit} form={form}>
      {/* <InltTermsModal
          hasReadTermsOfService={hasReadTermsOfService}
          handleConfirm={this.handleConfirm}
        />*/}
      <Form.Item help={null}>
        <h2>Enter a new password</h2>
      </Form.Item>
      <FormItem
        name={['newPassword']}
        rules={[{ required: true, message: ' ', min: 8 }]}
      >
        <Input
          prefix={<LockOutlined style={{ fontSize: 13 }} />}
          type="password"
          placeholder="New Password"
          disabled={isLoading}
        />
      </FormItem>
      <Form.Item shouldUpdate={shouldUpdate([['newPassword']])}>
        {() => (
          <FormItem
            name={['confirmNewPassword']}
            rules={[
              { required: true, message: ' ' },
              {
                type: 'enum',
                enum: [form.getFieldValue('newPassword')],
                message: ' ',
              },
            ]}
          >
            <Input
              prefix={<LockOutlined style={{ fontSize: 13 }} />}
              type="password"
              placeholder="Confirm Password"
              disabled={isLoading}
            />
          </FormItem>
        )}
      </Form.Item>
      <PasswordHelper form={form} />
      {/* flow === 'login' && (
          <Checkbox
            disable={!hasReadTermsOfService}
            checked={hasReadTermsOfService}
            onClick={this.handleShowInltTermsModal}
          >
            I have read the Terms of Service
          </Checkbox>
        )*/}
      <Button
        type="primary"
        htmlType="submit"
        className="login-form-button"
        // disabled={!hasReadTermsOfService && flow === 'login'*/}
        loading={isLoading}
      >
        Submit
      </Button>
    </Form>
  );
};

export default NewPasswordForm;
